<!-- This is Locum Mobile Menu Drawer -->
<template>
	<v-sheet>
		<v-navigation-drawer :value="value" fixed app @input="$emit('input', $event)">
			<v-list-item>
				<v-list-item-avatar v-if="!avatar">
					<v-img :src="no_avatar"></v-img>
				</v-list-item-avatar>
				<v-list-item-avatar v-else>
					<v-img :src="avatar"></v-img>
				</v-list-item-avatar>

				<v-list-item-content>
					<v-list-item-title>{{ usersName }}</v-list-item-title>
					<v-list-item-subtitle>{{ usersProfession }}</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>

			<v-divider></v-divider>

			<v-list dense>
				<template v-for="item in items">
					<v-list-item v-if="!item.hidden" :key="item.title" value="item.active" link>
						<v-list-item-content>
							<v-list-item v-if="item.onClick" slot="item" color="primary" class="text-center" @click="item.onClick">{{ item.title }}</v-list-item>
							<v-list-item v-else slot="item" router :to="item.to" :href="item.href" :target="item.target" color="primary" class="text-center">{{
								item.title
							}}</v-list-item>
						</v-list-item-content>
					</v-list-item>
				</template>
			</v-list>
			<v-spacer></v-spacer>
			<v-list>
				<v-list-item>
					<v-btn block :loading="apiRequest" color="secondary" @click="signOut">Sign Out</v-btn>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
	</v-sheet>
</template>

<script>
import store from '@/store';
import axios from 'axios';
import { getNavItems, authSignOut } from '@utils';

export default {
	name: 'MobileNavDrawer',

	props: {
		value: { type: Boolean, default: false },
		userType: { type: String, default: 'LOCUM' },
	},

	data: () => ({
		drawer: false,
		apiRequest: false,
		imageObj: {
			logo: null,
		},
		avatar: null,
		no_avatar: require('@/assets/images/avatars/user.png'),
	}),

	computed: {
		items() {
			return getNavItems(this.user.locale, this.tenant.settings.wallet.show);
		},
		usersProfession() {
			return store.getters.user?.profession || store.getters.company?.industry || null;
		},

		usersName() {
			return store.getters.user?.first_name || store.getters.user?.name || null;
		},

		LocumAvatar() {
			return store.getters.user.avatar_file;
		},
	},

	async created() {
		// retrieve the user
		this.user = store.getters.user;

		// choose which avatar to show
		if (this.$props.userType == 'LOCUM') this.avatar = this.LocumAvatar;
		else {
			// get the Practice avatar
			await this.getPracticeImages(this.imageObj);
			this.avatar = this.imageObj.logo;
		}
	},

	methods: {
		async signOut() {
			this.apiRequest = true;
			await authSignOut();
			this.apiRequest = false;
		},

		async getPracticeImages(imageObj) {
			try {
				const token = store.getters.jwtToken;
				let imageArr = store.getters.company?.documents?.images;
				const images = Object.keys(imageObj);
				for (let image of images) {
					if (imageArr?.includes(image)) {
						let res = await axios.get(store.getters.getDOCUMENTS + `/images/${image}/` + store.getters.company.id, { headers: { Authorization: token } });
						if (res.status === 200) {
							imageObj[image] = 'data:image/png;base64,' + res.data.data;
						}
					}
				}
			} catch (err) {
				console.error(err);
			}
		},
	},
};
</script>
